"use client";

import type { FC, Ref } from "react";
import { NeighbourhoodInformation } from "@huub-web/shared";
import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export interface NeighbourhoodInformationTemplateProps {
  neighbourhood: string;
  templates?: TemplateCollection;
}

/**
 * @deprecated
 */
export const NeighbourhoodInformationTemplate: FC<
  NeighbourhoodInformationTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ templates, ref, ...props }) => (
  <NeighbourhoodInformation ref={ref} {...props}>
    {templates && <TemplatesParser templates={templates} level={1} />}
  </NeighbourhoodInformation>
);
